import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import { MetricRow } from '../metricRows';
import { getAdaptiveTicks } from '../chartTicks';
import { MetricsSeriesChart } from '../Charts/MetricsSeriesChart';
import { RECORDS_COLOR, ERRORS_COLOR } from '../Charts/MetricsCombinedChart';
import styles from './MetricsSeparateCharts.module.scss';

export type MetricsSeparateChartsProps = {
  rows: MetricRow[];
  height?: number;
};

export const MetricsSeparateCharts = (props: MetricsSeparateChartsProps) => {
  const { rows, height = 150 } = props;

  const ticks = useMemo(() => getAdaptiveTicks(rows), [rows]);

  return (
    <Stack className={styles.container} gap="8px">
      <Stack className={styles.plot} role="group" aria-label="Records chart">
        <Typography className={styles.heading}>Records</Typography>
        <MetricsSeriesChart
          rows={rows}
          dataKey="records"
          label="Records"
          color={RECORDS_COLOR}
          ticks={ticks}
          showXLabels={false}
          height={height}
        />
      </Stack>

      <Stack className={styles.plot} role="group" aria-label="Errors chart">
        <Typography className={styles.heading}>Errors</Typography>
        <MetricsSeriesChart
          rows={rows}
          dataKey="errors"
          label="Errors"
          color={ERRORS_COLOR}
          ticks={ticks}
          showXLabels
          height={height}
        />
      </Stack>
    </Stack>
  );
};

MetricsSeparateCharts.displayName = 'MetricsSeparateCharts';
